import { render, staticRenderFns } from "./WA.vue?vue&type=template&id=47e744ec&scoped=true&"
import script from "./WA.vue?vue&type=script&lang=js&"
export * from "./WA.vue?vue&type=script&lang=js&"
import style0 from "./WA.vue?vue&type=style&index=0&id=47e744ec&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e744ec",
  null
  
)

export default component.exports